/**
 * Room name for user-scoped events (e.g. call status). Only that user's sockets receive events.
 */
export function getUserRoom(userId: string): string {
  return `user:${userId}`;
}

/**
 * Room name for company-scoped events (optional, for future use).
 */
export function getCompanyRoom(companyId: string): string {
  return `company:${companyId}`;
}
